import { render, staticRenderFns } from "./Funfact.vue?vue&type=template&id=f09fce5c&scoped=true&"
import script from "./Funfact.vue?vue&type=script&lang=js&"
export * from "./Funfact.vue?vue&type=script&lang=js&"
import style0 from "./Funfact.vue?vue&type=style&index=0&id=f09fce5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09fce5c",
  null
  
)

export default component.exports